module.exports = __webpack_public_path__ + "media/images/products/at2/at2-1-400x400-558da53531c319b32a7a5af81afbe370.png";